/* Custom inline scripts - extracted from theme.liquid for better performance */

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $('#blah').css('display', 'block');
      $('#blah').attr('src', e.target.result);
      var filename = $('input[type=file]').val().replace(/C:\\fakepath\\/i, '');
      $('.img_txt').text(input.files[0].name);
      $('.close_img').css('display', 'block');
      $('.file_label').css('display', 'none');
      $('.err_msg').css('display', 'none');
      $('.up_sub_img').addClass('aaaa');
    };
    reader.readAsDataURL(input.files[0]);
  } else {
    $('.up_sub_img').removeClass('aaaa');
  }
}

$(document).ready(function () {
  $(document).on("click", ".buy-buttons", function () {
    var f_val = $('.requried').val();
    if (f_val == '') {
      $('.err_msg').css('display', 'block');
    } else {
      $('.err_msg').css('display', 'none');
    }
  });

  $(document).on("click", ".clear_mg", function () {
    $(".close_img").css("display", "none");
    $(".img_txt").text(" ");
    $('.requried').val('');
    $('.file_label').css('display', 'block');
    $('.up_sub_img').removeClass('aaaa');
    $('.my_up').css('display', 'block');
  });

  $(document).on("click", ".my_up", function () {
    $(".requried").trigger("click");
    var f_val = $('.requried').val();
    if (f_val == '') {
      $('.my_up').css('display', 'none');
    } else {
      $('.file_label').css('display', 'block');
      $('.my_up').css('display', 'block');
      $('.err_msg').css('display', 'none');
    }
  });

  $(document).on("click", ".toggable .mini-cart__order-note-title", function () {
    $(this).toggleClass("toggle_show");
    $(".toggable .open_slid").slideToggle("500");
  });
});

/* Order note (cart drawer): save on button click + show confirmation.
   The button previously used data-action="close", which does nothing on this panel. */
(function () {
  var SAVED_VISIBLE_MS = 1800;
  var STRINGS = {
    saved: "Notiz gespeichert.",
    removed: "Notiz entfernt.",
    empty: "Bitte zuerst eine Notiz eingeben.",
    error: "Notiz konnte nicht gespeichert werden. Bitte erneut versuchen."
  };

  function panelOf(button) {
    return button.closest(".open_slid") || button.parentElement;
  }

  function setStatus(panel, message, state) {
    var status = panel && panel.querySelector(".order-note-status");
    if (!status) {
      return;
    }
    status.textContent = message || "";
    status.classList.toggle("order-note-status--error", state === "error");
    status.hidden = !message;
  }

  function collapsePanel() {
    if (!window.jQuery) {
      return;
    }
    window.jQuery(".toggable .open_slid").slideUp(300);
    window.jQuery(".toggable .mini-cart__order-note-title").removeClass("toggle_show");
  }

  function syncToggleLabel(note) {
    var toggle = document.getElementById("order-note-toggle");
    var strings = (window.themeVariables && window.themeVariables.strings) || {};
    if (!toggle) {
      return;
    }
    toggle.textContent = note === "" ? strings.cartAddOrderNote || "" : strings.cartEditOrderNote || "";
  }

  function saveOrderNote(button) {
    var panel = panelOf(button);
    var textarea = panel && panel.querySelector('textarea[name="note"]');
    if (!textarea || button.getAttribute("aria-busy") === "true") {
      return;
    }

    /* `defaultValue` is the note the page was rendered with, i.e. what the cart already holds.
       Empty field + nothing saved yet = nothing to do, so don't claim it was saved. Empty field
       with a note already on the cart is a deliberate removal and does need to be sent. */
    var note = textarea.value.trim();
    var savedNote = textarea.defaultValue.trim();
    if (note === "" && savedNote === "") {
      setStatus(panel, STRINGS.empty, "error");
      textarea.focus();
      return;
    }

    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    var cartUrl = routes.cartUrl || "/cart";

    button.setAttribute("aria-busy", "true");
    button.disabled = true;
    button.textContent = button.dataset.labelSaving || button.textContent;
    setStatus(panel, "");

    fetch(cartUrl + "/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: note })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Cart update failed with status " + response.status);
        }
        return response.json();
      })
      .then(function (cart) {
        var storedNote = cart.note == null ? "" : cart.note;

        /* Keep `defaultValue` in step with the cart so a second click is judged correctly. */
        textarea.defaultValue = storedNote;

        button.textContent = button.dataset.labelSaved || STRINGS.saved;
        button.classList.add("button--saved");
        setStatus(panel, note === "" ? STRINGS.removed : STRINGS.saved, "success");
        syncToggleLabel(storedNote);

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } })
        );

        window.setTimeout(function () {
          button.textContent = button.dataset.labelDefault || button.textContent;
          button.classList.remove("button--saved");
          button.removeAttribute("aria-busy");
          button.disabled = false;
          setStatus(panel, "");
          collapsePanel();
        }, SAVED_VISIBLE_MS);
      })
      .catch(function () {
        button.textContent = button.dataset.labelDefault || button.textContent;
        button.removeAttribute("aria-busy");
        button.disabled = false;
        setStatus(panel, STRINGS.error, "error");
      });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest('[data-action="save-order-note"]');
    if (!button) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    saveOrderNote(button);
  });
})();

/* Personalization: toggle line-item fields from variant.metafields.custom.personalisierbar (window.variantMetafields) */
jQuery(document).ready(function ($) {
  function getProductForm() {
    var $f = $('form[action*="/cart/add"]').first();
    return $f.length ? $f : $('form[is="product-form"]').first();
  }

  function getMetafieldForVariant(variantId) {
    var vm = window.variantMetafields;
    if (!vm || variantId == null || variantId === '') {
      return undefined;
    }
    var entry = vm[variantId] || vm[String(variantId)] || vm[Number(variantId)];
    return entry ? entry.my_metafield : undefined;
  }

  /** Same intent as legacy theme: hide fields when flag is explicitly “off” (not when missing/null). */
  function isPersonalizationDisabledRaw(meta) {
    if (meta === false) return true;
    if (typeof meta === 'string') {
      var s = meta.trim().toLowerCase();
      if (s === 'false' || s === '0') return true;
    }
    return false;
  }

  /** Legacy theme: `if ($("#m_selectedvar").val() == 'false')` — Liquid may output `False` / whitespace. */
  function mnSelectIndicatesPersonalizationDisabled() {
    var sel = $('#m_selectedvar').val();
    if (sel == null) return false;
    var s = String(sel).trim();
    return s !== '' && /^false$/i.test(s);
  }

  /** First paint: match JSON + `#m_selectedvar` (same as old inline after full page load). */
  function isPersonalizationDisabledOnInitialLoad(variantId) {
    return (
      isPersonalizationDisabledRaw(getMetafieldForVariant(variantId)) ||
      mnSelectIndicatesPersonalizationDisabled()
    );
  }

  /** Hidden rows must not be `required` or have a name, or native submit validation fails (not focusable). */
  function stripHiddenLineItemInputNames() {
    $('.product-form__line-item-property.hide_lineitem').each(function () {
      var $field = $(this).find('input.input__field, textarea.input__field').first();
      if (!$field.length) return;
      $field.removeAttr('name');
      $field.removeAttr('required');
    });
  }

  function ensurePropertyFieldCache() {
    $('.product-form__line-item-property').each(function () {
      var $field = $(this).find('input.input__field, textarea.input__field').first();
      if (!$field.length) return;
      var name = $field.attr('name');
      if (name && name.indexOf('properties[') === 0 && !$field.attr('data-ww-original-name')) {
        $field.attr('data-ww-original-name', name);
      }
      if ($field.attr('data-ww-was-required') == null) {
        $field.attr('data-ww-was-required', $field.prop('required') ? '1' : '0');
      }
    });
  }

  function syncMultiLineTxtLayout() {
    var lt = $('.line_txt').val();
    if (!lt || lt.length <= 1) return false;
    var result = lt
      .split(',')
      .map(function (s) {
        return String(s).trim();
      })
      .filter(function (s) {
        return s.length > 0;
      });
    var vnumItems = result.length;
    if (vnumItems === 0) return false;

    $('.product-form__line-item-property').addClass('hide_lineitem');

    $('.product-form__line-item-property').each(function (index) {
      if (index >= vnumItems) return;
      var labelText = result[index];
      var $row = $(this);
      $row.children('label').text(labelText);
      var $inp = $row.children('input, textarea').first();
      if ($inp.length) {
        var propName = 'properties[' + labelText + ']';
        $inp.attr('name', propName);
        $inp.attr('data-ww-original-name', propName);
      }
    });

    $('.product-form__line-item-property').each(function (index) {
      if (index < vnumItems) {
        $(this).removeClass('hide_lineitem');
        var $inp = $(this).children('input, textarea').first();
        if ($inp.length) {
          if (index === 0) {
            $inp.prop('required', true);
          } else {
            $inp.prop('required', false);
            $inp.removeAttr('required');
          }
        }
      }
    });
    stripHiddenLineItemInputNames();
    return true;
  }

  function showSinglePropertyFields() {
    $('.product-form__line-item-property').each(function () {
      var $wrap = $(this);
      var $field = $wrap.find('input.input__field, textarea.input__field').first();
      if (!$field.length) return;
      $wrap.removeClass('hide_lineitem');
      var on = $field.attr('data-ww-original-name');
      if (on) {
        $field.attr('name', on);
      }
      if ($field.attr('data-ww-was-required') === '1') {
        $field.prop('required', true);
      }
    });
  }

  function hidePersonalizationFields() {
    $('.product-form__line-item-property').each(function () {
      var $wrap = $(this);
      var $field = $wrap.find('input.input__field, textarea.input__field').first();
      if (!$field.length) return;
      $wrap.addClass('hide_lineitem');
      $field.removeAttr('required');
      $field.removeAttr('name');
    });
  }

  function refreshSchriftvorschau() {
    var vis = document.querySelector(
      '.product-form__line-item-property:not(.hide_lineitem) input[name^="properties["], ' +
        '.product-form__line-item-property:not(.hide_lineitem) textarea[name^="properties["]'
    );
    if (vis) {
      vis.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  /** @param {boolean} allow — false = ohne Personalisierung (nichts wird als properties[…] mitgeschickt) */
  function applyPersonalizationState(allow) {
    ensurePropertyFieldCache();
    if (!allow) {
      hidePersonalizationFields();
    } else if (!syncMultiLineTxtLayout()) {
      showSinglePropertyFields();
      stripHiddenLineItemInputNames();
    }
    refreshSchriftvorschau();
  }

  var $form = getProductForm();
  if (!$form.length) return;

  ensurePropertyFieldCache();

  var initialId = $form.find('[name="id"]').val();

  if (isPersonalizationDisabledOnInitialLoad(initialId)) {
    applyPersonalizationState(false);
  } else if ($('.line_txt').val() && $('.line_txt').val().length > 1) {
    syncMultiLineTxtLayout();
    refreshSchriftvorschau();
  } else if (getMetafieldForVariant(initialId) === true) {
    showSinglePropertyFields();
    stripHiddenLineItemInputNames();
    refreshSchriftvorschau();
  }

  $('.block-swatch__radio').on('click', function () {
    setTimeout(function () {
      $('#mn_select').load(location.href + ' #m_selectedvar');
    }, 100);
    setTimeout(function () {
      var vid = getProductForm().find('[name="id"]').val();
      var allowPersonalization = !(
        mnSelectIndicatesPersonalizationDisabled() ||
        isPersonalizationDisabledRaw(getMetafieldForVariant(vid))
      );
      applyPersonalizationState(allowPersonalization);
    }, 1500);
  });

  $form
    .off('change.wwLineItemPerso', '[name="id"]')
    .on('change.wwLineItemPerso', '[name="id"]', function () {
      var vid = $(this).val();
      applyPersonalizationState(!isPersonalizationDisabledRaw(getMetafieldForVariant(vid)));
    });
});

/* Cart drawer slick carousel */
$(document).ready(function () {
  var slickInitialized = false;
  var observer = new MutationObserver(function (mutations) {
    if (!slickInitialized && document.querySelector('cart-drawer[open] .loop_free_prod')) {
      slickInitialized = true;
      $('cart-drawer[open] .loop_free_prod').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev"><span>&larr; Zurück</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span>Weiter &rarr;</span></button>',
      });
    }
  });
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, subtree: true });
  }
});

/* Swiper mobile icon carousel */
$(document).ready(function () {
  var swiperInstance = null;

  function toggleSwiperInteraction() {
    var swiperContainer = $('.header_icon_text');
    if ($('.popup_div').hasClass('active')) {
      swiperContainer.addClass('swiper-no-swiping');
      $('.swiper-button-prev').css('pointer-events', 'none');
      $('.swiper-button-next').css('pointer-events', 'none');
      if (swiperInstance && swiperInstance.autoplay) {
        swiperInstance.autoplay.stop();
      }
    } else {
      swiperContainer.removeClass('swiper-no-swiping');
      $('.swiper-button-prev').css('pointer-events', 'unset');
      $('.swiper-button-next').css('pointer-events', 'unset');
      if (swiperInstance && swiperInstance.autoplay) {
        swiperInstance.autoplay.start();
      }
    }
  }

  $('.popupbox').on('click', function () {
    $('.popup_div').removeClass('active');
    $(this).siblings('.popup_div').addClass('active');
    toggleSwiperInteraction();
  });

  $('.popup_div .close').on('click', function () {
    $('.popup_div').removeClass('active');
    toggleSwiperInteraction();
  });

  function initSwiper() {
    if ($(window).width() <= 767) {
      if (!swiperInstance) {
        swiperInstance = new Swiper('.header_icon_text', {
          slidesPerView: 1,
          spaceBetween: 10,
          autoplay: {
            delay: 3000,
          },
          navigation: {
            nextEl: '.header_icon_text .swiper-button-next',
            prevEl: '.header_icon_text .swiper-button-prev',
          },
        });
        $('.header_icon_text .swiper-button-prev').css('display', 'flex');
        $('.header_icon_text .swiper-button-next').css('display', 'flex');
      }
    } else {
      if (swiperInstance) {
        $('.header_icon_text .swiper-button-prev').css('display', 'none');
        $('.header_icon_text .swiper-button-next').css('display', 'none');
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  initSwiper();
  $(window).on('resize', function () {
    initSwiper();
  });
});
